import { ADD_ATAEVENT } from "../constants/requestUrls";

import { postRequest } from "../request";

const addAtaEvent = (data) => {
  return postRequest({ url: ADD_ATAEVENT, data });
}

export default addAtaEvent;